module.exports = __webpack_public_path__ + "static/media/team-member.b31db74f.png";